// Visibility logic shared by Sidebar, MobileNav, and lazy tab gates in
// StaffRecommend. Centralizes the rule:
//
//   - Owner: always sees an item if the role allows it (toggles ignored).
//   - Non-admin staff: role-only (no toggles in UI for them anyway).
//   - Admin: Admin status itself unlocks admin modules. For items with a
//     `permKey`, the toggle is the source of truth (default ON, except
//     earnings/pay_config which default OFF). For items without a permKey
//     (Tasks, Schedule, Reporting, etc.), fall back to role.
//
// `Settings` is special — no role module, isAdmin + `settings` toggle only.

// Modules that default to OFF for admins when no permission record exists.
// Mirrors TeamSettings.jsx — financial data is opt-in, not opt-out.
const DEFAULT_OFF_KEYS = new Set(['earnings', 'pay_config', 'month_end']);

function getPerm(sess, key) {
  return (sess?.opsPermissions || []).find(p => p.module === key);
}

function defaultFor(key) {
  return !DEFAULT_OFF_KEYS.has(key);
}

export function canAccessSettings(sess) {
  if (!sess) return false;
  if (sess.opsRole === 'owner') return true;
  if (!sess.opsIsAdmin) return false;
  const perm = getPerm(sess, 'settings');
  return perm ? perm.canAccess : defaultFor('settings');
}

export function isItemVisible(item, sess) {
  return canModule(sess, item.moduleKey || item.module);
}

// Effective-module check — the single access gate. Owner always true.
export function canModule(sess, key) {
  if (!sess) return false;
  if (sess.opsRole === 'owner') return true;
  return Array.isArray(sess.modules) && sess.modules.includes(key);
}

// For non-nav features (Earnings sub-tab, KPIs sub-tab, etc) where there's
// no nav item but we want to gate by a permission key.
export function canAccessByKey(sess, permKey) { return canModule(sess, permKey); }
